const handleSubmitValidation = (finalObjet, validStateTemp) => {
    let validCount = 0;

    Object.keys(validStateTemp).map(key => {
        if (validStateTemp[key] && validStateTemp[key].conditions['required'] && !validStateTemp[key]['changed']) {
            if (finalObjet[key] === null || finalObjet[key] === "") {
                validCount++;
                validStateTemp[key]['valid'] = false;
                validStateTemp[key]['changed'] = true;
                validStateTemp[key]['message'] = "This feild is required!"
            } else if (validStateTemp[key].conditions['type'] && validStateTemp[key].conditions['type'] === "array") {
                if (!Array.isArray(finalObjet[key])) {
                    validCount++;
                    validStateTemp[key]['valid'] = false;
                    validStateTemp[key]['changed'] = true;
                    validStateTemp[key]['message'] = "Pattern mismatched!"
                } else if (finalObjet[key].length === 0) {
                    validCount++;
                    validStateTemp[key]['valid'] = false;
                    validStateTemp[key]['changed'] = true;
                    validStateTemp[key]['message'] = "This feild is required!"
                }
            }

        } else if (validStateTemp[key] && validStateTemp[key].conditions['required'] && validStateTemp[key]['changed'] && !validStateTemp[key]['valid']) {
            validCount++;
        } else if (validStateTemp[key] && validStateTemp[key].conditions['conditionalRequired']
            && validStateTemp[key].conditions['conditionField']
            && validStateTemp[key].conditions['conditionValue']
            && finalObjet.hasOwnProperty(validStateTemp[key].conditions['conditionField']) && !validStateTemp[key]['changed']) {
            if (validStateTemp[key].conditions['conditionOperator'] && validStateTemp[key].conditions['conditionOperator'] === "eq" && finalObjet[validStateTemp[key].conditions['conditionField']] === validStateTemp[key].conditions['conditionValue']) {
                if (finalObjet[key] === null || finalObjet[key] === "") {
                    validCount++;
                    validStateTemp[key]['valid'] = false;
                    validStateTemp[key]['changed'] = true;
                    validStateTemp[key]['message'] = "This feild is required!"
                }else{
                    validStateTemp[key]['valid'] = true;
                }
            } else if (validStateTemp[key].conditions['conditionOperator'] 
            && validStateTemp[key].conditions['conditionOperator'] === "neq" && 
            finalObjet[validStateTemp[key].conditions['conditionField']] !== validStateTemp[key].conditions['conditionValue']
            &&finalObjet[validStateTemp[key].conditions['conditionField']]!=="") {
                if (finalObjet[key] === null || finalObjet[key] === "") {
                    validCount++;
                    validStateTemp[key]['valid'] = false;
                    validStateTemp[key]['changed'] = true;
                    validStateTemp[key]['message'] = "This feild is required!"
                }else{
                    validStateTemp[key]['valid'] = true;
                }
            }
        } else if (validStateTemp[key] && validStateTemp[key].conditions['conditionalRequired']
            && validStateTemp[key].conditions['conditionField']
            && validStateTemp[key].conditions['conditionValue']
            && finalObjet.hasOwnProperty(validStateTemp[key].conditions['conditionField']) && validStateTemp[key]['changed']) {
            if (validStateTemp[key].conditions['conditionOperator'] && validStateTemp[key].conditions['conditionOperator'] === "eq"
            ) {
                if (finalObjet[validStateTemp[key].conditions['conditionField']] === validStateTemp[key].conditions['conditionValue']) {
                    if (finalObjet[key] === null || finalObjet[key] === "") {
                        validCount++;
                        validStateTemp[key]['valid'] = false;
                        validStateTemp[key]['changed'] = true;
                        validStateTemp[key]['message'] = "This feild is required!"
                    } else {
                        validStateTemp[key]['valid'] = true;
                    }
                } else {
                    validStateTemp[key]['valid'] = true;
                }

            } else if (validStateTemp[key].conditions['conditionOperator'] && validStateTemp[key].conditions['conditionOperator'] === "neq"
            ) {
                if (finalObjet[validStateTemp[key].conditions['conditionField']] !== validStateTemp[key].conditions['conditionValue']) {
                    if (finalObjet[key] === null || finalObjet[key] === "") {
                        validCount++;
                        validStateTemp[key]['valid'] = false;
                        validStateTemp[key]['changed'] = true;
                        validStateTemp[key]['message'] = "This feild is required!"
                    } else {
                        validStateTemp[key]['valid'] = true;
                    }
                } else {
                    validStateTemp[key]['valid'] = true;
                }

            }
        }


    })
    return { validStateTemp: validStateTemp, validCount: validCount }
}

export default handleSubmitValidation;